import { FelaCSS, spacing } from '@bridebook/ui';

interface IStyles {
  columnsOrientation: FelaCSS;
}

interface IStyleProps {
  itemsCount: number;
}

const styles = ({ itemsCount }: IStyleProps): IStyles => ({
  columnsOrientation: {
    gridAutoFlow: 'column',
    gridTemplateRows: `repeat(${Math.ceil(itemsCount / 3)}, auto)`,
    gridTemplateColumns: 'repeat(3, 1fr)',
    columnGap: spacing[6],
    maxWidthMobileSm: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gridTemplateRows: `repeat(${Math.ceil(itemsCount / 2)}, auto)`,
    },
  },
});

export default styles;
